import { getEmail, getPartnerUserId } from "./QueryString";
import moment from "moment-timezone";
import { v4 as uuidv4 } from 'uuid';
import * as Storage from "./SetLocalstorage";
// uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'

export const tryGetEmail =(appConfig)=>{
    let qsEmail = getEmail() || null;
      if(!qsEmail){
        const qsPartnerId = getPartnerUserId();
        // if(!qsPartnerId){
        //   setError({ text: "email or partnerId is mandatory!" });
        //   return;
        // }
        if(qsPartnerId)
          qsEmail = `${qsPartnerId}@${appConfig?.partnerDomain || "fake1.m-events.com"}`
        else{
          let uuid = uuidv4();
          let isDynamicExist = false;
          const dynamicUser = Storage.get(`dynamic_user_uuid`);
          if(dynamicUser && dynamicUser?.date === moment().format("YYYY-MM-DD")){
            //NOTE: alredy made for today
            uuid = dynamicUser?.uuid;
            isDynamicExist=true;
          }
          qsEmail = `${uuid}@${appConfig?.partnerDomain || "fake1.m-events.com"}`;
          if(!isDynamicExist)
            Storage.store(`dynamic_user_uuid`,{
              date: moment().format("YYYY-MM-DD"),
              uuid:uuid
            });
        } 
    }
    return qsEmail;
};